import React from "react";
import SympotmFormPage from "../components/sympotms/SympotmFormPage";

const SympotmCreate = () => <SympotmFormPage mode="create" />;

export default SympotmCreate;
